import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import { Box, Button, Typography } from '@mui/material';

interface ConfigurationMissingScreenProps {
  reason: string;
  detail: string;
  envName: string;
}

export function ConfigurationMissingScreen({
  reason,
  detail,
  envName,
}: ConfigurationMissingScreenProps) {
  return (
    <Box
      sx={{
        position: 'fixed',
        zIndex: 9999,
        top: 0,
        left: 0,
        width: '100vw',
        height: '100dvh',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        px: 4,
      }}
    >
      <ErrorOutlinedIcon sx={{ fontSize: 64, color: '#0F172A' }} />
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          textAlign: 'center',
        }}
      >
        Configurazione mancante
        <br />
        <Typography
          component="span"
          variant="h6"
          sx={{
            fontWeight: 400,
            color: 'text.secondary',
          }}
        >
          Configuration missing
        </Typography>
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          textAlign: 'center',
        }}
      >
        L&apos;app non è stata configurata correttamente. Contatta il supporto e riprova più tardi.
        <br />
        The app is not properly configured. Please contact support and try again later.
      </Typography>
      <Box
        sx={{
          mt: 1,
          p: 2,
          backgroundColor: '#F8FAFC',
          borderRadius: 1,
          border: '1px solid #E2E8F0',
          width: '100%',
          maxWidth: 480,
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{
            fontWeight: 600,
            mb: 0.5,
          }}
        >
          Dettagli tecnici / Technical details
        </Typography>
        <Typography
          variant="caption"
          component="pre"
          sx={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-word', m: 0 }}
        >
          {`reason: ${reason}\ndetail: ${detail}\nenv: ${envName}`}
        </Typography>
      </Box>
      <Button
        variant="contained"
        fullWidth
        sx={{ maxWidth: 320, mt: 1 }}
        onClick={() => window.location.reload()}
      >
        Riprova
        <Typography
          component="span"
          variant="caption"
          sx={{ display: 'block', lineHeight: 1, opacity: 0.8 }}
        >
          Retry
        </Typography>
      </Button>
    </Box>
  );
}
